// MUTATIONS
export const SET_IS_EDIT_MODE = 'partnerPricing/SET_IS_EDIT_MODE'
export const SET_SELECTED_COUNTRY = 'partnerPricing/SET_SELECTED_COUNTRY'
export const SET_SUPPORTED_COUNTRIES = 'partnerPricing/SET_SUPPORTED_COUNTRIES'
export const SET_PRICING = 'partnerPricing/SET_PRICING'
export const SET_PRICING_TO_SAVED = 'partnerPricing/SET_PRICING_TO_SAVED'
export const SET_RECOURSE_TO_SAVED = 'partnerPricing/SET_RECOURSE_TO_SAVED'
export const SET_IS_CONFIG_NOT_FOUND = 'partners/SET_IS_CONFIG_NOT_FOUND'

// ACTIONS
export const ACTIVATE_EDIT_MODE = 'partnerPricing/ACTIVATE_EDIT_MODE'
export const GET_PRICING_ETP = 'partnerPricing/GET_PRICING_ETP'
export const GET_PRICING_ETR = 'partnerPricing/GET_PRICING_ETR'
export const CHANGE_PRICING_TO_SAVED = 'partnerPricing/CHANGE_PRICING_TO_SAVED'
export const CHANGE_RECOURSE_TO_SAVED =
  'partnerPricing/CHANGE_RECOURSE_TO_SAVED'
export const UPDATE_PRICING_ETP = 'partnerPricing/UPDATE_PRICING_ETP'
export const UPDATE_PRICING_ETR = 'partnerPricing/UPDATE_PRICING_ETR'
export const CHANGE_IS_CONFIG_NOT_FOUND = 'partners/CHANGE_IS_CONFIG_NOT_FOUND'
export const GET_PRICING_COMPANY_ETR = 'partnerPricing/GET_PRICING_COMPANY_ETR'
export const UPDATE_PRICING_COMPANY_ETR =
  'partnerPricing/UPDATE_PRICING_COMPANY_ETR'
